module.exports = __webpack_public_path__ + "static/media/Megan.8f586297.png";